import { render, staticRenderFns } from "./uber_general_tab.vue?vue&type=template&id=ad5a269a&scoped=true&"
import script from "./uber_general_tab.vue?vue&type=script&lang=js&"
export * from "./uber_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5a269a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad5a269a')) {
      api.createRecord('ad5a269a', component.options)
    } else {
      api.reload('ad5a269a', component.options)
    }
    module.hot.accept("./uber_general_tab.vue?vue&type=template&id=ad5a269a&scoped=true&", function () {
      api.rerender('ad5a269a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/uber/location/tabs/uber_general_tab.vue"
export default component.exports